import {
  Box,
  Paper,
  Skeleton,
  Divider,
} from '@mui/material';

const OrderDetailsSkeleton = ({ theme }) => {
  return (
    <Paper
      elevation={6}
      sx={{
        p: { xs: 2, md: 4 },
        borderRadius: 4,
        bgcolor: theme.palette.background.paper,
        border: `1.5px solid ${theme.palette.warning.main}`,
        height: "100%",
        maxHeight: "100%",
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box"
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexShrink: 0 }}>
        <Skeleton 
          variant="text" 
          width="60%" 
          height={32}
        />
        <Skeleton 
          variant="rectangular" 
          width={120} 
          height={40} 
          sx={{ borderRadius: 2 }} 
        />
      </Box>
      
      <Divider sx={{ mb: 2, flexShrink: 0 }} />
      
      <Box sx={{ 
        flex: 1,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column"
      }}>
        <Skeleton 
          variant="rectangular" 
          width="100%" 
          height="100%"
          sx={{ 
            borderRadius: 2,
            bgcolor: "rgba(0, 0, 0, 0.04)"
          }} 
        />
      </Box>
    </Paper>
  );
};

export default OrderDetailsSkeleton;